import { FC, memo } from 'react'
// import { Box } from '@chakra-ui/react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const FolderLinkOutline = createIcon({
  displayName: 'FolderLinkOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M20.467 17.5l.554-.554 -8.77051e-08 8.425e-08c1.11463-1.07072 1.20989-2.82167.218-4.007l9.84118e-08 1.09618e-07c-1.0445-1.16344-2.8344-1.25986-3.99784-.215362 -.037996.0341116-.0750622.069245-.111158.105362l-.667.667"></path>
        <path d="M14.461 15.5l-.554.554 2.81476e-07-2.70387e-07c-1.11463 1.07072-1.20989 2.82167-.218001 4.007l-1.51023e-07-1.6822e-07c1.0445 1.16344 2.8344 1.25986 3.99784.215362 .037996-.0341116.0750622-.069245.111158-.105362l.667-.667"></path>
        <line x1="15.8" x2="19.13" y1="18.17" y2="14.83"></line>
        <path d="M21 9v-1.06 0c0-1.10457-.895431-2-2-2h-6.471l5.06946e-09-2.57216e-12c-.332272.000168565-.642928-.164715-.829-.44l-1.4-2.063 -1.47521e-09-2.16555e-09c-.186752-.274145-.497291-.437843-.829-.437h-4.471l-8.74228e-08 1.77636e-15c-1.10457 4.82823e-08-2 .895431-2 2v12l2.30926e-14 3.01992e-07c1.66785e-07 1.10457.895431 2 2 2h5"></path>
      </g>
      <path fill="none" d="M0 0h24v24h-24Z"></path>
    </>
  ),
})

const FolderLink: FC<CustomIconProps> = (props) => {
  // if (props.variant === 'twoTone') return <CustomIcon as={FolderLinkTwoTone} {...props} />

  return <CustomIcon as={FolderLinkOutline} {...props} />
}

export default memo(FolderLink)
